import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import MyButton from '../../../utils/MyButton';
import { FaArrowCircleLeft } from 'react-icons/fa';
import TablaEquipos from './TablaEquipos';

import './InventarioPerfil.css';

export class InventarioPerfil extends Component {
  render() {
    const { clienteId } = this.props.match.params;
    const { tipouser } = this.props.user.credentials;

    const rutaVolver =
      tipouser === 'Tecnico'
        ? `/dashboard/perfilclientetec/${clienteId}`
        : `/dashboard/perfilcliente/${clienteId}`;

    return (
      <div>
        <div className="titulo_section">
          <div className="titulo_clientes">
            <h1 className="text-clientes">Inventario de Equipos</h1>
            <hr className="clientes_separator" />
          </div>

          <div className="div_boton">
            <Link to={rutaVolver}>
              <MyButton tip="Volver">
                <FaArrowCircleLeft color="#03178C" className="icon-eliminarcliente" />
              </MyButton>
            </Link>
          </div>
        </div>

        <div className="container-inventario-perfil">
          <div className="div-tabla-equipos">
            <TablaEquipos clienteId={clienteId} />
          </div>
        </div>
      </div>
    );
  }
}

InventarioPerfil.propTypes = {
  user: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(InventarioPerfil);